export type LogRegistryLeafNode = Record<string, never>;
export type LogRegistry = {
    [key: string]: LogRegistry | LogRegistryLeafNode;
};

export const LOG_REGISTRY = Object.freeze({
    rcToggler: {},
    utils: {
        auth: {},
        patchMirage: {},
        ensureCrossOriginIsolation: {},
    },
    camera: {
        useHandleCameraMoved: {},
    },
    svgRenderer: {
        wrapper: {},
        lib: {},
    },
    telemetry: {},
    miniMap: {
        levelsTree: {},
        utils: {},
        miniMapWeb: {},
    },
    measure: {
        preloadBrep: {},
    },
    analytics: {},
});
